<template>
	<div class="baseInfo p-[50px] box-border  ">
		<div class="flex">

			<div class="w-[40%] leftInfo relative mr-[100px]">
				<div class="flex items-start mb-[20px]">
					<label
						class="min-w-[90px] px-[10px] box-border text-[14px] text-[#999999]">{{langInfo.avatar}}:</label>
					<el-upload class="avatar-uploader" :action="$apiUrl+'api/v1.index/upload'" :show-file-list="false"
						:http-request="httpRequest" :headers="headers">
						<img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div class="el-upload__tip" slot="tip">{{langInfo.avatar_tip}}</div>
					</el-upload>
				</div>
				<div class="flex items-start mb-[14px]">
					<label
						class="min-w-[90px] px-[10px] box-border text-[14px] text-[#999999]">{{langInfo.user_nickname}}:</label>
					<input v-model="userInfo.username" class="w-[180px] text-[#C1C2C5] text-[14px] rounded-[3px]"
						type="text" :placeholder="langInfo.user_nickname_tip" />
				</div>
				<div class="flex items-start mb-[19px]">
					<label
						class="min-w-[90px] px-[10px] box-border text-[14px] text-[#999999]">{{langInfo.login_email}}:</label>
					<input v-model="userInfo.email" class="w-[180px] text-[#C1C2C5] text-[14px] rounded-[3px]"
						type="text" :placeholder="langInfo.login_email_tip" />
				</div>
				<div class="flex items-start mb-[20px]">
					<label
						class="min-w-[90px] px-[10px] box-border text-[14px] text-[#999999]">{{langInfo.user_gender}}:</label>
					<div class="flex-1">
						<el-radio-group v-model="userInfo.gender" @input="inputGender">
							<el-radio class="mr-[20px] mb-[10px]" :label="1">{{langInfo.male}}</el-radio>
							<el-radio class="mr-[20px] mb-[10px]" :label="2">{{langInfo.female}}</el-radio>
							<el-radio :label="0">{{langInfo.confidential}}</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="flex items-start mb-[19px]">
					<label
						class="min-w-[90px] px-[10px] box-border text-[14px] text-[#999999]">{{langInfo.language_preference}}:</label>
					<el-select class="w-[180px] text-[#C1C2C5] text-[14px] rounded-[3px]" @change="changeLang"
						v-model="userInfo.lang" :placeholder="langInfo.please_select">
						<el-option v-for="item in langOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="w-[33%]">
				<div class="flex items-start mb-[30px]">
					<div class="min-w-[90px] px-[10px] box-border text-[14px] text-[#000000]">
						{{langInfo.optional_section}}
					</div>
				</div>
				<div class="flex items-start justify-between mb-[19px]">
					<label class="w-[70px] text-[14px] text-[#999999]">{{langInfo.age}}:</label>
					<el-select class="w-[210px] text-[#C1C2C5] text-[14px] rounded-[3px]" @change="changeAge"
						v-model="userInfo.dict_age_id" :placeholder="langInfo.please_select">
						<el-option v-for="item in ageOption" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="flex items-start justify-between mb-[19px]">
					<label class=" text-[14px] text-[#999999]">{{langInfo.country_region}}:</label>
					<el-select class="w-[190px] text-[#C1C2C5] text-[14px] rounded-[3px]" @change="changeCity"
						v-model="userInfo.dict_country_id" :placeholder="langInfo.please_select">
						<el-option v-for="item in cityOption" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="flex items-start justify-between mb-[19px]">
					<label class=" text-[14px] text-[#999999]">{{langInfo.occupation_student}}:</label>
					<el-select class="w-[190px] text-[#C1C2C5] text-[14px] rounded-[3px]" @change="changeProfessional"
						v-model="userInfo.dict_professional_id" :placeholder="langInfo.please_select">
						<el-option v-for="item in professionalOption" :key="item.id" :label="item.title"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="flex items-start justify-between mb-[19px]">
					<label class=" text-[14px] text-[#999999]">{{langInfo.Cert_Interest}}:</label>
					<el-select multiple class="w-[190px] text-[#C1C2C5] text-[14px] rounded-[3px]" @change="changeCert"
						v-model="userInfo.dict_certificate_ids" :placeholder="langInfo['select cert type (multiple)']">
						<el-option v-for="item in certList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>
				<div class="flex items-start justify-between mb-[19px]">
					<label class=" text-[14px] text-[#999999]">{{langInfo.learning_objectives}}:</label>
					<el-input v-model="userInfo.learning_goal" type="textarea"
						class="w-[190px] text-[#C1C2C5] text-[14px] rounded-[3px] "
						:placeholder="langInfo.learning_objectives_tip"></el-input>
				</div>
			</div>
		</div>
		<div @click="saveBtn()"
			class="w-[250px] h-[36px] cursor-pointer leading-[36px] text-center text-[#ffffff] rounded-[5px] bg-[#FF0000] mx-auto">
			{{langInfo.save_btn}}
		</div>
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	export default {
		data() {
			return {
				langOptions: [{
					value: 'zh',
					label: '' //中文
				}, {
					value: 'en',
					label: '' //英文
				}, {
					value: 'cht',
					label: '' //繁体
				}],

				ageOption: [],
				cityOption: [],
				professionalOption: [],
				certList: [],

				userInfo: {
					username: '',
					avatar: "",
					email: "",
					learning_goal: "",
					gender: "",
					lang: '',
					dict_age_id: '',
					dict_country_id: "",
					dict_professional_id: '',
					dict_certificate_ids: [],
				},
				headers: {
					"user-token": localStorage.getItem('token'),
					"server": 1
				},
				langInfo: {},
				is_edit: 0
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log(to.query.is_edit); // 获取查询参数
				// 你可以在这里处理查询参数的变化
				this.is_edit = to.query.is_edit
			}
		},
		mounted() {
			if (this.$route.query.is_edit) {
				this.is_edit = this.$route.query.is_edit
			}
			// 昵称=username
			// avatar=头像
			// email=邮箱
			// gender=性别:0=未知,1=男,2=女
			// dict_certificate_id 证书名称
			// dict_professional_id    职业/学生身份
			// dict_country_id 国家/地区
			// dict_age_id 年龄范围
			// lang    语言 zh中文 en英文 cht繁体
			// learning_goal   学习目标
			this.getUser()
			this.getAgeList()
			this.getCityList()
			this.getProfessionalOption()
			this.getCertList()

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.langOptions[0].label = this.langInfo.zh
				this.langOptions[1].label = this.langInfo.en
				this.langOptions[2].label = this.langInfo.cht
				document.title = this.langInfo.pc_name + '-' + this.langInfo.study_my_set
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.langOptions[0].label = this.langInfo.zh
					this.langOptions[1].label = this.langInfo.en
					this.langOptions[2].label = this.langInfo.cht
					document.title = this.langInfo.pc_name + '-' + this.langInfo.study_my_set

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			httpRequest(item) {
				console.log(item);
				// var imgId = item.file.lastModified
				console.log(item.file.name);

				var formData = new FormData()
				formData.append('file', item.file)

				console.log(formData);
				console.log(this.$api.upload);
				this.$api.upload(formData).then((res) => {
					console.log(res.data.file.url);
					this.userInfo.avatar = res.data.file.url
				}).catch((error) => {
					console.log(error);
				})
			},
			getUser() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					this.userInfo.dict_country_id = this.userInfo.dict_country_id ? this.userInfo.dict_country_id :
						""
					this.userInfo.dict_professional_id = this.userInfo.dict_professional_id ? this.userInfo
						.dict_professional_id : ""
					this.userInfo.dict_age_id = this.userInfo.dict_age_id ? this.userInfo.dict_age_id : ""
					localStorage.setItem('userInfo', JSON.stringify(res.data))



				}).catch((error) => {
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getAgeList() {
				this.$api.age_list().then((res) => {
					console.log(res.data);
					this.ageOption = res.data

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getCityList() {
				this.$api.country_list().then((res) => {
					console.log(res.data);
					this.cityOption = res.data

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getProfessionalOption() {
				this.$api.professional_list().then((res) => {
					console.log(res.data);
					this.professionalOption = res.data

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getCertList() {
				this.$api.certificate_list().then((res) => {
					console.log(res.data);
					this.certList = res.data

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 设置性别
			inputGender(e) {
				console.log(e);
				this.userInfo.gender = e
			},
			// 设置语言
			changeLang(e) {
				console.log(e);
				this.userInfo.lang = e
			},
			changeAge(e) {
				console.log(e);
				this.userInfo.dict_age_id = e
			},
			changeCity(e) {
				console.log(e);
				this.userInfo.dict_country_id = e
			},
			changeProfessional(e) {
				this.userInfo.dict_professional_id = e
			},
			changeCert(e) {
				console.log(e);
				this.userInfo.dict_certificate_ids = e
			},

			saveBtn() {
				let param = {
					username: this.userInfo.username,
					email: this.userInfo.email,
					dict_age_id: this.userInfo.dict_age_id,
					dict_country_id: this.userInfo.dict_country_id,
					dict_professional_id: this.userInfo.dict_professional_id,
					dict_certificate_ids: this.userInfo.dict_certificate_ids.length > 0 ? this.userInfo.dict_certificate_ids : '',
					avatar: this.userInfo.avatar,
					gender: this.userInfo.gender,
					lang: this.userInfo.lang,
					learning_goal: this.userInfo.learning_goal
				}

				const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
				if (!emailPattern.test(this.userInfo.email.trim())) {
					this.$message({
						message: this.langInfo['reg_tip_content'],
						type: 'warning'
					})
					return
				}
				console.log(param);
			
				this.$api.user_edit(param).then((res) => {
					console.log(res);
					this.$api.user_info().then((res) => {
						console.log(res.data);
						this.userInfo = res.data

						this.userInfo = res.data
						this.userInfo.dict_country_id = this.userInfo.dict_country_id ? this.userInfo
							.dict_country_id : ""
						this.userInfo.dict_professional_id = this.userInfo.dict_professional_id ? this
							.userInfo.dict_professional_id : ""
						this.userInfo.dict_age_id = this.userInfo.dict_age_id ? this.userInfo.dict_age_id :
							"";

						// if(res.data.is_background_addition==1){

						// 	this.$router.push('/personalCenter/updatePass'); // 使用完整路径

						// }
						this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径

						localStorage.setItem('userInfo', JSON.stringify(res.data))
						this.$store.dispatch('user/setUserInfo', res.data)

						EventBus.$emit('userInfo', res.data)

					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
					this.$message({
						message: "保存成功",
						type: 'success'
					});

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					});
				})
			}


		}
	}
</script>

<style scoped>
	.leftInfo::after {
		content: '';
		position: absolute;
		width: 1px;
		height: 178px;
		background-color: rgba(217, 217, 217, 1);
		right: 0;
		top: 16%;


	}

	/deep/.el-textarea__inner {
		height: 124px;
		padding-left: 10px;
		padding-right: 10px;
		font-size: 14px;
		color: #C1C2C5;
	}

	/deep/textarea::placeholder {
		color: #C1C2C5;
		/* 例如，设置为灰色 */
	}

	/deep/.el-input__inner {
		height: 25px;
		padding-left: 10px;
		padding-right: 10px;
	}

	/deep/.el-input__icon {
		line-height: normal;
	}

	input {
		padding: 4px 10px;
		box-sizing: border-box;
		border: 1px solid rgba(220, 224, 231, 1);
		background-color: transparent;
	}

	input::placeholder {
		color: #A6A6A6;
		/* 例如，设置为灰色 */
	}

	/deep/.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	/deep/.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	/deep/.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 64px;
		height: 64px;
		line-height: 64px;
		text-align: center;
		border-radius: 50%;
	}

	/deep/ .avatar {
		width: 64px;
		height: 64px;
		display: block;
	}
</style>